import React, {useRef} from 'react';
import styled from 'styled-components';
import PersonIcon from '@material-ui/icons/Person';
import { useDispatch } from 'react-redux';
import { logout } from '../../../../store/actions/login';
import PopoverMenu from '../../../PopoverMenu/PopoverMenu';
import { ListItemText, MenuItem, MenuList } from '@material-ui/core';
import SyncIcon from '@material-ui/icons/Sync';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from 'react-router';
import {openCashTrayAction} from "../../../../pages/reception/PosPage/pages/Sale/actions";

const UserMenuList = styled.div`
  margin: 5px 0;

  a {
    text-decoration: none;
  }
`;

const TopMenu = styled.div`
  height: 60px;
  padding: 10px 20px;
  text-align: right;
  align-items: center;
  justify-content: flex-end;
  display: flex;
`;

const Navbar = ({showOpenCashDrawer}) => {
  const openDrawerButtonRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const openDrawer = () => {
      dispatch(openCashTrayAction());
      openDrawerButtonRef?.current?.blur();
  }

  return (
    <TopMenu>
      <IconButton onClick={() => history.go(0)}>
        <SyncIcon/>
      </IconButton>
      {showOpenCashDrawer && <IconButton onClick={openDrawer} ref={openDrawerButtonRef}>
        <VpnKeyIcon />
      </IconButton>}
      <PopoverMenu icon={<PersonIcon />}>
        <UserMenuList>
          <MenuList id="menu-list-grow">
            <MenuItem
              button
              onClick={() => {
                dispatch(logout());
              }}>
              <ListItemText primary={'Odhlásit'} />
            </MenuItem>
          </MenuList>
        </UserMenuList>
      </PopoverMenu>
    </TopMenu>
  );
};

export default Navbar;
